import { render, staticRenderFns } from "./PointDonation.vue?vue&type=template&id=5fc65f64&"
import script from "./PointDonation.js?vue&type=script&lang=js&"
export * from "./PointDonation.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports